import $ from 'jquery';

const $questMenu = $('#menu-quest-menu').CFDynamicMenu();

global.dynamicMenuAddSubmenuItems = function dynamicMenuAddSubmenuItems(submenuSelector, content) {
  $questMenu.CFDynamicMenu('addSubmenuItems', submenuSelector, content);
};

global.dynamicMenuAddSubmenuItemsAfterSubmenuItem =
  function dynamicMenuAddSubmenuItemsAfterSubmenuItem(submenuItem, submenuItems) {
    $questMenu.CFDynamicMenu('addSubmenuItemsAfterSubmenuItem', submenuItem, submenuItems);
  };

global.dynamicMenuUpdateSubmenuItems = (submenuSelector, content) => {
  $questMenu.CFDynamicMenu('updateSubmenuItems', submenuSelector, content);
};

global.dynamicMenuActivateSubmenuItem = function dynamicMenuActivateSubmenuItem(submenuItem) {
  $questMenu.CFDynamicMenu('activateMenuItem', submenuItem);
};



// WEBPACK FOOTER //
// ./assets/js/dynamic-menu.js